/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateStockupRequestStockup } from './CreateStockupRequestStockup';
import {
    CreateStockupRequestStockupFromJSON,
    CreateStockupRequestStockupFromJSONTyped,
    CreateStockupRequestStockupToJSON,
} from './CreateStockupRequestStockup';

/**
 * 
 * @export
 * @interface CreateStockupRequest
 */
export interface CreateStockupRequest {
    /**
     * 
     * @type {CreateStockupRequestStockup}
     * @memberof CreateStockupRequest
     */
    stockup: CreateStockupRequestStockup;
}

/**
 * Check if a given object implements the CreateStockupRequest interface.
 */
export function instanceOfCreateStockupRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stockup" in value;

    return isInstance;
}

export function CreateStockupRequestFromJSON(json: any): CreateStockupRequest {
    return CreateStockupRequestFromJSONTyped(json, false);
}

export function CreateStockupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStockupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stockup': CreateStockupRequestStockupFromJSON(json['stockup']),
    };
}

export function CreateStockupRequestToJSON(value?: CreateStockupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stockup': CreateStockupRequestStockupToJSON(value.stockup),
    };
}

